import { createFileRoute } from "@tanstack/react-router";
import TMSCandidacy from "@/pages/TMSCandidacy";
export const Route = createFileRoute("/tms-candidacy")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS Candidacy & Eligibility | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Am I a candidate for TMS? Check eligibility for SAINT® TMS and standard TMS for depression at Neuro Wellness in Coral Springs, FL. Free candidacy screening.",
        },
        {
          property: "og:title",
          content: "TMS Candidacy & Eligibility | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Am I a candidate for TMS? Check eligibility for SAINT® TMS and standard TMS for depression at Neuro Wellness in Coral Springs, FL. Free candidacy screening.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/tms-candidacy",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/tms-candidacy",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TMSCandidacy />;
}
